import axios from 'axios';

const base = (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/+$/, '');

if (!base) {
  console.error('NEXT_PUBLIC_API_URL is not set. API calls will fail.');
}

// Check if the URL already includes /v1 to avoid double versioning
const baseURL = base.endsWith('/v1') ? base : `${base}/v1`;

export const apiClient = axios.create({
  baseURL: baseURL || '/v1',
});
